import { type Dispatch, type SetStateAction, useEffect, useState } from "react";

export const useSessionStorageState = <T>(
  key: string,
  defaultValue: T | (() => T),
): [T, Dispatch<SetStateAction<T>>] => {
  const [value, setValue] = useState(() => {
    try {
      const text = sessionStorage.getItem(key);
      if (text === null) throw "";
      const parsed = JSON.parse(text) as { value: T };
      if (parsed === undefined) throw "";
      return parsed.value;
    } catch (_error) {
      return typeof defaultValue !== "function" ? defaultValue : (defaultValue as () => T)();
    }
  });

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify({ value }));
  }, [value, key]);

  return [value, setValue] as const;
};
